import {Component, input}                                                            from '@angular/core';
import {FormsModule}                                                                 from '@angular/forms';
import {VapeRatioKeyType, VapeRecordLogIntf, VapeTypes, VapeTypesDict, VapeTypesDry} from '@djsharkk/logr-types';
import {InputWrapperComponent}                                                       from '../../../forms/input-wrapper/input-wrapper.component';
import {DialogEditBase}                                                              from '../dialog-edit-base';

@Component({
			   selector   : 'app-dialog-edit-vape',
			   imports: [
				   InputWrapperComponent,
				   FormsModule
			   ],
			   templateUrl: './dialog-edit-vape.component.html',
			   styleUrl   : './dialog-edit-vape.component.css'
		   })
export class DialogEditVapeComponent extends DialogEditBase<VapeRecordLogIntf> {
	rec = input.required<VapeRecordLogIntf>();
	protected readonly VapeTypesDry = VapeTypesDry;
	protected readonly VapeTypes = VapeTypes;
	protected readonly VapeTypesDict = VapeTypesDict;

	onRatioChange() {
		const r = this.rec();
		if (!r.ratio) return;
		// r.ratio['sativa'] = +value; // Update the value for the slider
		r.ratio['indica'] = 100 - r.ratio['sativa']; // Ensure the total stays at 100
	}

}
